document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    if (event.target.matches(".trigger-more-info")) {
      event.preventDefault();
      var moreInfoButton = event.target;
      var moreInfoBackground = moreInfoButton.nextElementSibling;
      var moreInfoModal = moreInfoBackground.firstElementChild;
      var moreInfoClose = moreInfoModal.firstElementChild;
      moreInfoBackground.classList.add("active"); //remove class hiding the modal background

      moreInfoClose.focus();
    } //if the more info link is clicked

  });
  document.addEventListener('keydown', closeVariationModal, false);

  function closeVariationModal(evt) {
    evt = evt || window.event;
    var isEscape = false;

    if ("key" in evt) {
      isEscape = evt.key === "Escape" || evt.key === "Esc";
    } else {
      isEscape = evt.key === 27;
    }

    if (isEscape) {
      var moreInfoModal = document.querySelectorAll(".modal-more-info.active"),
          i;

      for (i = 0; i < moreInfoModal.length; ++i) {
        moreInfoModal[i].classList.remove("active");
      }
    }
  }

  ;
  document.addEventListener("click", function (event) {
    if (event.target.matches(".close-modal")) {
      event.preventDefault();
      var closeButton = event.target;
      var moreInfoModal = closeButton.closest(".modal");
      moreInfoModal.parentNode.classList.remove("active"); //add class to modal
    } //if the close button is clicked

  });
}); // Tab key changes focus between anchors and close button.

document.addEventListener("keyup", function (e) {
  if (e.which == 9) {
    var currentModal;
    document.querySelectorAll(".modal-more-info").forEach(function (modal) {
      if (modal.classList.contains("active")) {
        currentModal = modal;
        var modalCloseButton = currentModal.querySelector("a");

        if (document.activeElement == modalCloseButton) {
          currentModal.querySelector("a").focus();
        } else {
          currentModal.querySelector(".close-modal").focus();
        }
      }
    });
  }
}); // Close modal if user clicks outside.

document.addEventListener("click", function (e) {
  var currentModal;
  document.querySelectorAll(".modal-more-info").forEach(function (modal) {
    if (modal.classList.contains("active")) {
      currentModal = modal;
    }
  });

  if (!e.target.closest(".modal") && currentModal) {
    currentModal.classList.toggle("active");
  }
});